import React, { useState, useEffect } from 'react';
import { Todo, TodoFormData } from '../types/todo';

interface TodoFormProps {
  initialData: Todo | null;
  onSubmit: (data: TodoFormData) => void;
  onCancel: () => void;
}

const TodoForm: React.FC<TodoFormProps> = ({
  initialData,
  onSubmit,
  onCancel
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [errors, setErrors] = useState<{ title?: string }>({});

  // 編集モードの場合、初期データをセット
  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title);
      setDescription(initialData.description || '');
      setDueDate(initialData.due_date ? initialData.due_date.split('T')[0] : '');
    } else {
      setTitle('');
      setDescription('');
      setDueDate('');
    }
  }, [initialData]);

  const validate = (): boolean => {
    const newErrors: { title?: string } = {};

    if (!title.trim()) {
      newErrors.title = 'タイトルは必須です';
    } else if (title.length > 100) {
      newErrors.title = 'タイトルは100文字以内で入力してください';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }

    const formData: TodoFormData = {
      title: title.trim(),
      description: description.trim(),
      due_date: dueDate || null
    };

    onSubmit(formData);
  };

  return (
    <form className="todo-form" onSubmit={handleSubmit}>
      <h2>{initialData ? 'ToDoを編集' : '新しいToDoを追加'}</h2>

      <div className="form-group">
        <label htmlFor="title">タイトル *</label>
        <input
          type="text"
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="タイトルを入力してください"
          autoFocus
        />
        {errors.title && (
          <span style={{ color: '#dc2626', fontSize: '0.85rem', marginTop: '5px', display: 'block' }}>
            {errors.title}
          </span>
        )}
      </div>

      <div className="form-group">
        <label htmlFor="description">説明</label>
        <textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="詳細な説明を入力してください（任意）"
        />
      </div>

      <div className="form-group">
        <label htmlFor="dueDate">期限日</label>
        <input
          type="date"
          id="dueDate"
          value={dueDate}
          onChange={(e) => setDueDate(e.target.value)}
        />
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          キャンセル
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? '更新する' : '追加する'}
        </button>
      </div>
    </form>
  );
};

export default TodoForm;
